var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"range-picker-ruler"},_vm._l((_vm.size),function(n){return _c('li',{key:n,ref:"items",refInFor:true})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }